import React from 'react'
import moment from 'moment'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import Group from 'components/utils/Group'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { connect } from 'react-redux'
import Heading from 'LuxKit/Typography/Heading'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
interface MappedProps {
  canViewLuxPlusBenefits: boolean
}
interface Props extends MappedProps {
  bookByDate: string
  travelByDate: string
}

function BnblPackageDatesGift(props: Props) {
  const { bookByDate, travelByDate, canViewLuxPlusBenefits } = props

  return (
    <Group direction="vertical" gap={8} tabletGap={16}>
      <BodyText variant="medium">Buying this as a gift locks in today’s price for your recipient. They can choose travel dates later.</BodyText>

      <Group direction="vertical" gap={0}>
        <Heading variant="heading5" style={{ marginBottom: 8 }}>How it works</Heading>
        <BodyText variant="medium">
          <strong>1. Secure your escape today</strong> to lock in the price.
        </BodyText>
        <BodyText variant="medium">
          <strong>2. The recipient can choose dates</strong> anytime before <strong>{moment(bookByDate).format(DMY_CASUAL_FORMAT)}</strong> in recipient's account.
        </BodyText>
        <BodyText variant="medium">
          <strong>3. Manage their booking online</strong> and travel by <strong>{moment(travelByDate).format(DMY_CASUAL_FORMAT)}</strong>.
        </BodyText>
      </Group>

      <Group direction="vertical">
        <MessageBanner kind="informational-primary" density="compact">
          <Group direction="horizontal" gap={8} verticalAlign="center">
            <LineInfoCircleIcon />
            <BodyText variant="medium">
              Subject to availability and surcharges (peak period or property-specific). Any surcharges will be shown before confirming your dates.
            </BodyText>
          </Group>
        </MessageBanner>
        {canViewLuxPlusBenefits && <Caption colour="neutral-three" variant="medium">*Member pricing does not apply when giving a  package as a gift.</Caption>}
      </Group>
    </Group>
  )
}

function mapStateToProps(state: App.State): MappedProps {
  return {
    canViewLuxPlusBenefits: getCanViewLuxPlusBenefits(state),
  }
}

export default connect(mapStateToProps)(BnblPackageDatesGift)
